
import React from 'react';
import { Search, ListPlus, FileText, Download, BarChart2 } from 'lucide-react';
import { CrawlStage } from '@/components/loading/CrawlStagesList';

export const getCrawlStages = (stage: string, progress: number): CrawlStage[] => {
  // Normalize the stage name for comparison
  const normalizedStage = stage.toLowerCase();
  
  const stages = [
    {
      title: "Fetching sitemap...",
      icon: React.createElement(Search, { className: "h-5 w-5" }),
      isActive: normalizedStage.includes('fetch') || normalizedStage.includes('sitemap'),
      isCompleted: progress > 30
    },
    {
      title: "Processing URLs...",
      icon: React.createElement(ListPlus, { className: "h-5 w-5" }),
      isActive: normalizedStage.includes('process') || normalizedStage.includes('urls'),
      isCompleted: progress > 90
    },
    {
      title: "Completing...",
      icon: React.createElement(FileText, { className: "h-5 w-5" }),
      isActive: normalizedStage.includes('complet'),
      isCompleted: progress >= 100
    }
  ];
  
  // If we can't determine the active stage from the name, default to progress-based activity
  let hasActiveStage = stages.some(s => s.isActive);
  
  if (!hasActiveStage) {
    if (progress < 30) stages[0].isActive = true;
    else if (progress < 90) stages[1].isActive = true;
    else stages[2].isActive = true;
  }
  
  return stages;
};
